import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { tradePromoOptimizationUrls } from 'config/urls';
import { BulkExportReportStatus, OPTIMIZATION_POLLING_INTERVAL, PENDING_BULK_EXPORT_STATUSES } from 'constants/tpo';
import { BulkExportReportRow } from 'utils/getTradePromoOptimizationTableColumns';

type UseReportPollerArgs = {
    reportId: number | string;
    initialStatus?: string;
    onUpdate: (id: number | string, patch: Partial<BulkExportReportRow>) => void;
};

export const useReportPoller = ({ reportId, initialStatus, onUpdate }: UseReportPollerArgs) => {
    const [pollingStatus, setPollingStatus] = useState<string>(initialStatus ?? BulkExportReportStatus.QUEUED);

    const pollingFn = async () => {
        try {
            const { data } = await axios.get(tradePromoOptimizationUrls.getReportStatusUrl(reportId));
            setPollingStatus(data?.status);
            onUpdate(reportId, {
                status: data?.status,
                error_message: data?.error_message ?? null,
                updated_at: data?.updated_at ?? undefined,
            });
            return data;
        } catch (err: any) {
            setPollingStatus(BulkExportReportStatus.ERROR);
            return err?.message;
        }
    };

    useQuery({
        queryKey: ['tpo_report_status', reportId],
        queryFn: pollingFn,
        refetchInterval: PENDING_BULK_EXPORT_STATUSES.has(pollingStatus) ? OPTIMIZATION_POLLING_INTERVAL : false,
        enabled: !!reportId,
        staleTime: 0,
    });
};
